import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {tagSchema} from "../../schema/tagSchema";
import {getFormData} from "../../models/tagModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form"
import {createRestaurantTag} from "../../store/tag-slice";

const TagAdd = () => {

    const navigator = useNavigate();
    const dispatch = useDispatch();

    const {
        createStatus,
        error
    } = useSelector(state => state.tag);

    const list = useSelector(state => state.list);
    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        if (createStatus === "success") {
            navigator("..");
        }
    }, [createStatus, dispatch, navigator]);

    const formSubmitHandler = (data) => {
        delete data.showInReport;
        const updatedData = {
            ...data,
            id: userRole.scopeId
        }
        dispatch(createRestaurantTag({...userRole, data: updatedData}));
    }

    const formCancelHandler = () => {
        navigator("..");
    }

    const schema = tagSchema({list});
    delete schema.showInReport;

    const initialData = getFormData();

    return (
        <>
            <SubHeader title="Add Tag">
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-12 col-lg-8 col-xl-4">
                        <Form onFormSubmit={formSubmitHandler}
                              onFormCancel={formCancelHandler}
                              schema={schema}
                              inline={false}
                              initialData={initialData}
                              status={createStatus}
                              error={error}/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TagAdd;
